import React, { useState, useEffect } from "react";

// Package Import

import {
  Typography,
  Box,
  useTheme,
  Grid,
  Paper,
  Chip,
  TableContainer,
  TableHead,
  Table,
  TableRow,
  TableCell,
  TableBody,
  Button,
} from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import { format } from "date-fns";

// User Import

import {
  GlobeBlueIcon,
  ProfileIcon,
  PopulationServedIcon,
  InventoryIcon,
  UnitsDeliveredIcon,
  ExpiredDosesIcon,
  WastedDosesIcon,
  TempratureIcon,
} from "../../../../Svg";
import Barchart from "../../../shared/Barchart";
import {
  RoutesUrls,
  ministryRoutes,
  commonRoutes,
} from "../../../../Services/Routes/APP";
import { headersPost } from "../../../../Services/API";
import { DISTRICTS_API_ULRS } from "../../../../Services/Routes/API";

// Component

const DetailsDistrict = () => {
  // Hooks

  const theme = useTheme();
  const { state } = useLocation();
  const navigate = useNavigate();

  const headings = [
    "Batch#",
    "Quantity",
    "Type",
    "Expiry Date",
    "Storage Temprature",
    "Received Date",
  ];

  const transactions = [
    {
      batchNo: "12345",
      quantity: "5000",
      type: "Vaccine",
      expiry: "04-09-2022",
      storageTemprature: "10 Degree",
      receivedDate: "02-07-2022",
    },
    {
      batchNo: "12345",
      quantity: "5000",
      type: "Vaccine",
      expiry: "04-09-2022",
      storageTemprature: "10 Degree",
      receivedDate: "02-07-2022",
    },
    {
      batchNo: "12345",
      quantity: "5000",
      type: "Vaccine",
      expiry: "04-09-2022",
      storageTemprature: "10 Degree",
      receivedDate: "02-07-2022",
    },
    {
      batchNo: "12345",
      quantity: "5000",
      type: "Vaccine",
      expiry: "04-09-2022",
      storageTemprature: "10 Degree",
      receivedDate: "02-07-2022",
    },
    {
      batchNo: "12345",
      quantity: "5000",
      type: "Vaccine",
      expiry: "04-09-2022",
      storageTemprature: "10 Degree",
      receivedDate: "02-07-2022",
    },
    {
      batchNo: "12345",
      quantity: "5000",
      type: "Vaccine",
      expiry: "04-09-2022",
      storageTemprature: "10 Degree",
      receivedDate: "02-07-2022",
    },
    {
      batchNo: "12345",
      quantity: "5000",
      type: "Vaccine",
      expiry: "04-09-2022",
      storageTemprature: "10 Degree",
      receivedDate: "02-07-2022",
    },
    {
      batchNo: "12345",
      quantity: "5000",
      type: "Vaccine",
      expiry: "04-09-2022",
      storageTemprature: "10 Degree",
      receivedDate: "02-07-2022",
    },
  ];
  // States
  const [barChartData, setBarChartData] = useState(null);
  const [alertOpen, setAlertOpen] = useState(false);
  const [alertMsg, setAlertMsg] = useState("");
  const [alertIcon, setAlertIcon] = useState("error");

  const batchesOfDistrictHandler = () => {
    navigate(
      RoutesUrls?.ministryAdmin +
        ministryRoutes?.districts +
        commonRoutes?.batches,

      {
        state: {
          node: state?.node,
          childRole: "district",
        },
      }
    );
  };

  const seeDetailsHandler = (row) => {
    navigate(RoutesUrls?.ministryAdmin + commonRoutes?.batch?.details, {
      state: {
        vaccines: row,
      },
    });
  };

  // vaccination details for barchart
  const getVaccinationDetails = () => {
    const data = {
      details_request: {
        view_level: "district",
        view_level_id: state?.node?.id,
      },
    };
    headersPost(DISTRICTS_API_ULRS.GET_DASHBOARD_DATA, data)
      .then((res) => {
        if (res?.status === 200 && res?.data?.success) {
          setBarChartData(res.data?.barChartData);
        } else {
          setAlertOpen(true);
          setAlertMsg(res?.data?.message);
          setAlertIcon("warning");
        }
      })
      .catch((err) => {
        const { response } = err;
        if (response?.status === 401) {
          localStorage.clear();
          navigate(RoutesUrls?.ministryAdmin + ministryRoutes?.detailsDistrict);
        } else {
          setAlertOpen(true);
          setAlertMsg(response?.statusText);
          setAlertIcon("error");
        }
      });
  };

  const yearSixMonthsAgo = () => {
    let d = new Date();
    d.setMonth(d.getMonth() - 6);
    return d.getFullYear();
  };

  const currentYear = () => {
    let d = new Date();
    return d.getFullYear();
  };

  // life cycle

  useEffect(() => {
    getVaccinationDetails();
  }, [state]);

  // Render

  return (
    <Box>
      <Grid
        container
        spacing={2}
        sx={{
          overflow: { xs: "hidden", sm: "hidden", md: "hidden", lg: "hidden" },
        }}
      >
        <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
          <Paper>
            <Box padding={{ xs: 1, sm: 2 }}>
              <Typography variant="h6" component="div">
                General information
              </Typography>
              <Typography sx={{ mb: 1.5 }} color="text.secondary">
                {state?.node?.name}
              </Typography>
              {/* 1 ROW */}
              <Grid
                container
                display={"flex"}
                justifyContent={"space-between"}
                sx={{ mb: 1.5 }}
              >
                <Box display={"flex"} alignItems={"center"}>
                  <Box
                    height={"60px"}
                    width={"60px"}
                    display={"flex"}
                    alignItems={"center"}
                    justifyContent={"center"}
                    sx={{
                      backgroundColor: `${theme.palette.secondary.dark}`,
                      borderRadius: 1.5,
                    }}
                  >
                    <GlobeBlueIcon />
                  </Box>
                  <Typography
                    ml={2}
                    sx={{ paddingTop: 1.8, textAlign: "left" }}
                  >
                    District
                  </Typography>
                </Box>
                <Box sx={{ paddingTop: 1.2 }}>
                  <Chip
                    sx={{
                      minWidth: "70px",
                      color: "blue",
                      borderRadius: 1,
                    }}
                    label={state?.node?.name}
                  />
                </Box>
              </Grid>
              {/* 2nd Row */}
              <Grid
                container
                display={"flex"}
                justifyContent={"space-between"}
                sx={{ mb: 1.5 }}
              >
                <Box display={"flex"} alignItems={"center"}>
                  <Box
                    height={"60px"}
                    width={"60px"}
                    display={"flex"}
                    alignItems={"center"}
                    justifyContent={"center"}
                    sx={{
                      backgroundColor: `${theme.palette.secondary.dark}`,
                      borderRadius: 1.5,
                    }}
                  >
                    <ProfileIcon />
                  </Box>
                  <Typography ml={2} sx={{ paddingTop: 1.8 }}>
                    Population
                  </Typography>
                </Box>
                <Box sx={{ paddingTop: 1.2 }}>
                  <Chip
                    sx={{
                      minWidth: "70px",
                      color: "blue",
                      borderRadius: 1,
                    }}
                    label={state?.node?.population}
                  />
                </Box>
              </Grid>
              {/* 3rd Row */}
              <Grid
                container
                display={"flex"}
                justifyContent={"space-between"}
                sx={{ mb: 1.5 }}
              >
                <Box display={"flex"} alignItems={"center"}>
                  <Box
                    height={"60px"}
                    width={"60px"}
                    display={"flex"}
                    alignItems={"center"}
                    justifyContent={"center"}
                    sx={{
                      backgroundColor: `${theme.palette.secondary.dark}`,
                      borderRadius: 1.5,
                    }}
                  >
                    <PopulationServedIcon />
                  </Box>
                  <Box>
                    <Typography
                      variant="body1"
                      component="div"
                      ml={2}
                      sx={{ paddingTop: 1 }}
                    >
                      Population Served
                    </Typography>

                    <Typography
                      ml={2}
                      color="text.secondary"
                      sx={{ fontSize: "12px" }}
                    >
                      Updated at{" "}
                      {state?.node?.updated_at
                        ? format(
                            new Date(state?.node?.updated_at),
                            "MM/dd/yyyy"
                          )
                        : ""}
                    </Typography>
                  </Box>
                </Box>
                <Box sx={{ paddingTop: 1.2 }}>
                  <Chip
                    sx={{
                      minWidth: "70px",
                      color: "blue",
                      borderRadius: 1,
                    }}
                    label={state?.node?.vaccinated || 0}
                  />
                </Box>
              </Grid>
              {/* 4th Row */}
              <Grid
                container
                display={"flex"}
                justifyContent={"space-between"}                                                         
                sx={{ mb: 1.5 }} 
              >
                <Box display={"flex"} alignItems={"center"}> 
                  <Box
                    height={"60px"}
                    width={"60px"}
                    display={"flex"}
                    alignItems={"center"}
                    justifyContent={"center"}
                    sx={{
                      backgroundColor: `${theme.palette.secondary.dark}`,
                      borderRadius: 1.5,
                    }}
                  >
                    <InventoryIcon />
                  </Box>{" "}
                  <Box>
                    <Typography
                      variant="body1"
                      component="div"
                      ml={2}
                      sx={{ paddingTop: 1 }}
                    >
                      Current Inventory
                    </Typography>
                    <Typography
                      ml={2}
                      color="text.secondary"
                      sx={{ fontSize: "12px" }}
                    >
                      Updated 30 Minutes ago
                    </Typography>
                  </Box>
                </Box>
                <Box sx={{ paddingTop: 1.2 }}>
                  <Chip
                    label={state?.node?.current_inventory}
                    sx={{
                      minWidth: "70px",
                      color: "blue",
                      borderRadius: 1,
                    }}
                  />
                </Box>
              </Grid>
            </Box>
          </Paper>
        </Grid>
        <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
          {/* <Grid container padding={2}> */}
          <Paper>
            <Box
              padding={{ xs: 1, sm: 2 }}
              // minWidth={{ xs: 300, sm: 780, lg: "400px" }}
            >
              <Typography variant="h6" component="div">
                Inventory information
              </Typography>
              <Typography sx={{ mb: 1.5 }} color="text.secondary">
                {state?.node?.name}
              </Typography>

              {/* 1st Row */}
              <Grid
                container
                display={"flex"}
                justifyContent={"space-between"}
                sx={{ mb: 1.5 }}
              >
                <Box display={"flex"} alignItems={"center"}>
                  <Box
                    height={"60px"}
                    width={"60px"}
                    display={"flex"}
                    alignItems={"center"}
                    justifyContent={"center"}
                    sx={{
                      backgroundColor: `${theme.palette.secondary.dark}`,
                      borderRadius: 1.5,
                    }}
                  >
                    <TempratureIcon />
                  </Box>{" "}
                  <Box>
                    <Typography
                      variant="body1"
                      component="div"
                      ml={2}
                      sx={{ paddingTop: 1 }}
                    >
                      Storage Temprature
                    </Typography>
                    <Typography
                      ml={2}
                      color="text.secondary"
                      sx={{ fontSize: "12px" }}
                    >
                      Updated 30 Minutes ago
                    </Typography>
                  </Box>
                </Box>
                <Box sx={{ paddingTop: 1.2 }}>
                  <Chip
                    sx={{
                      minWidth: "70px",
                      color: "blue",
                      borderRadius: 1,
                    }}
                    label={state?.node?.storage_temperature || "N/A"}
                  />
                </Box>
              </Grid>
              {/* 2nd Row */}
              <Grid
                container
                display={"flex"}
                justifyContent={"space-between"}
                sx={{ mb: 1.5 }}
              >
                <Box display={"flex"} alignItems={"center"}>
                  <Box
                    height={"60px"}
                    width={"60px"}
                    display={"flex"}
                    alignItems={"center"}
                    justifyContent={"center"}
                    sx={{
                      backgroundColor: `${theme.palette.secondary.dark}`,
                      borderRadius: 1.5,
                    }}
                  >
                    <UnitsDeliveredIcon />
                  </Box>{" "}
                  <Box>
                    <Typography
                      variant="body1"
                      component="div"
                      ml={2}
                      sx={{ paddingTop: 1 }}
                    >
                      Units Delivered
                    </Typography>
                    <Typography
                      ml={2}
                      color="text.secondary"
                      sx={{ fontSize: "12px" }}
                    >
                      Updated 30 Minutes ago
                    </Typography>
                  </Box>
                </Box>
                <Box sx={{ paddingTop: 1.2 }}>
                  <Chip
                    sx={{
                      minWidth: "70px",
                      color: "blue",
                      borderRadius: 1,
                    }}
                    label={state?.node?.delivered_dose}
                  />
                </Box>
              </Grid>
              {/* 3rd Row */}
              <Grid
                container
                display={"flex"}
                justifyContent={"space-between"}
                sx={{ mb: 1.5 }}
              >
                <Box display={"flex"} alignItems={"center"}>
                  <Box
                    height={"60px"}
                    width={"60px"}
                    display={"flex"}
                    alignItems={"center"}
                    justifyContent={"center"}
                    sx={{
                      backgroundColor: `${theme.palette.secondary.dark}`,
                      borderRadius: 1.5,
                    }}
                  >
                    <ExpiredDosesIcon />
                  </Box>{" "}
                  <Box>
                    <Typography
                      variant="body1"
                      component="div"
                      ml={2}
                      sx={{ paddingTop: 1 }}
                    >
                      Expired Doses
                    </Typography>
                    <Typography
                      ml={2}
                      color="text.secondary"
                      sx={{ fontSize: "12px" }}
                    >
                      Updated 30 Minutes ago
                    </Typography>
                  </Box>
                </Box>
                <Box sx={{ paddingTop: 1.2 }}>
                  <Chip
                    sx={{
                      minWidth: "70px",
                      color: "blue",
                      borderRadius: 1,
                    }}
                    label={state?.node?.quantity_expired || 0}
                  />
                </Box>
              </Grid>
              {/* 4th Row */}
              <Grid
                container
                display={"flex"}
                justifyContent={"space-between"}
                sx={{ mb: 1.5 }}
              >
                <Box display={"flex"} alignItems={"center"}>
                  <Box
                    height={"60px"}
                    width={"60px"}
                    display={"flex"}
                    alignItems={"center"}
                    justifyContent={"center"}
                    sx={{
                      backgroundColor: `${theme.palette.secondary.dark}`,
                      borderRadius: 1.5,
                    }}
                  >
                    <WastedDosesIcon />
                  </Box>{" "}
                  <Box>
                    <Typography
                      variant="body1"
                      ml={2}
                      component="div"
                      sx={{ paddingTop: 1 }}
                    >
                      Wasted Doses
                    </Typography>
                    <Typography
                      ml={2}
                      color="text.secondary"
                      sx={{ fontSize: "12px" }}
                    >
                      Updated 30 Minutes ago
                    </Typography>
                  </Box>
                </Box>
                <Box sx={{ paddingTop: 1.2 }}>
                  <Chip
                    sx={{
                      minWidth: "70px",
                      color: "blue",
                      borderRadius: 1,
                    }}
                    label={state?.node?.quantity_wasted || 0}
                  />
                </Box>
              </Grid>
            </Box>
          </Paper>
          {/* </Grid> */}
        </Grid>
      </Grid>
      <Box>
        {barChartData && (
          <Grid item mt={2}>
            <Paper>
              <Box padding={{ xs: 2, sm: 4 }}>
                <Typography sx={{ paddingY: 1 }} variant="h5">
                  Monthly Overview
                </Typography>
                <Typography variant="p" color={"text.grayText"}>
                  Population Served per month
                </Typography>
                <Box display="flex" justifyContent={"center"}>
                  <Barchart height={400} data={barChartData} />
                </Box>
                <Typography
                  variant="body2"
                  textAlign={"center"}
                  style={{ marginTop: "25px" }}
                >
                  {yearSixMonthsAgo == currentYear
                    ? `Year ${currentYear()}`
                    : `Year ${yearSixMonthsAgo()} - ${currentYear()}`}
                </Typography>
              </Box>
            </Paper>
          </Grid>
        )}
      </Box>
      <Paper elevation={1} sx={{ marginTop: 5, paddingX: 3, paddingTop: 5 }}>
        {" "}
        <TableContainer>
          <Table sx={{ marginTop: 3 }} aria-label="simple table">
            <TableHead>
              <TableRow>
                {headings?.map((h, index) => (
                  <TableCell
                    sx={{
                      fontWeight: "bold",
                      borderBottom: "none",
                    }}
                    align="center"
                    key={`${index}-table-heading-${h}`}
                  >
                    <Chip
                      label={h}
                      sx={{
                        backgroundColor: theme.palette.secondary.dark,
                        borderRadius: 1,
                        color: theme.palette.primary.main,
                      }}
                    ></Chip>
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {state?.node?.latest_batches?.map((row, index) => (
                <TableRow key={`${index}-row.name-${index + 21}`}>
                  <TableCell align="center">{row?.reference_number}</TableCell>
                  <TableCell align="center">{row?.size}</TableCell>
                  <TableCell align="center">{row?.main_type}</TableCell>
                  <TableCell align="center">
                    {row?.expiry_date
                      ? format(new Date(row?.expiry_date), "MM/dd/yyyy")
                      : ""}
                  </TableCell>
                  <TableCell align="center">
                    {row?.previous_temperature}
                  </TableCell>
                  <TableCell align="center">
                    {row?.received_date
                      ? format(new Date(row?.received_date), "MM/dd/yyyy")
                      : ""}
                  </TableCell>
                  <TableCell align="center">
                    {" "}
                    <Button
                      onClick={() => {
                        seeDetailsHandler(row);
                      }}
                    >
                      {" "}
                      see details{" "}
                    </Button>{" "}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
        <Box display={"flex"} justifyContent={"center"}>
          <Button onClick={batchesOfDistrictHandler}>See more</Button>
        </Box>
      </Paper>
    </Box>
  );
};

export default DetailsDistrict;
